import { motion } from "framer-motion";
import { PartyPopper } from "lucide-react";

const fmtDate = (iso) =>
  new Intl.DateTimeFormat("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(new Date(iso));

export default function SuccessOverlay({ info, onDone }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[70] flex items-center justify-center bg-black/80 p-6 backdrop-blur-md"
    >
      <motion.div
        initial={{ scale: 0.85, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="glass-card w-full max-w-md rounded-3xl p-8 text-center sm:p-10"
      >
        <motion.div
          initial={{ rotate: -12, scale: 0 }}
          animate={{ rotate: 0, scale: 1 }}
          transition={{ delay: 0.15, type: "spring", stiffness: 200, damping: 12 }}
          className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-yellow-400 shadow-[0_0_40px_rgba(250,204,21,0.5)]"
        >
          <PartyPopper className="h-7 w-7 text-black" />
        </motion.div>
        <div data-testid="registration-success-message">
          <h3 className="font-display text-4xl uppercase leading-none tracking-wide text-white">
            You're in.
          </h3>
          <p className="mt-4 text-sm leading-relaxed text-slate-300 sm:text-base">
            <span className="font-bold text-yellow-400">{info.teamName}</span> is on the bracket for{" "}
            <span className="font-bold text-white">{fmtDate(info.tournament.start)}</span>. Squad of{" "}
            {info.players}. Lace up — the court is waiting.
          </p>
        </div>
        <button
          data-testid="success-done-btn"
          onClick={onDone}
          className="mt-8 inline-flex w-full items-center justify-center rounded-full bg-yellow-400 px-6 py-3.5 font-heading text-sm font-bold uppercase tracking-widest text-black transition-transform hover:scale-[1.03] active:scale-95"
        >
          Back to the bracket
        </button>
      </motion.div>
    </motion.div>
  );
}
